module.exports = __webpack_public_path__ + "static/media/example2.264b754b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Layout/About/example2.gif
// module id = 1238
// module chunks = 2